import { DESKTOP_NAVBAR_CLASS_NAME } from '../../constants/mui-components';

const MuiToolbar = {
  styleOverrides: {
    root: {
      [`&.${DESKTOP_NAVBAR_CLASS_NAME}`]: {
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: 'white',
        borderRadius: '6.25rem',
        margin: '0.75rem 2.5rem',
        height: '3.5rem',
        minHeight: '3.5rem',
        boxShadow: '0.25rem 0.25rem 5rem 0 rgba(0, 0, 0, 0.12)',
      },
    },
  },
};

export default MuiToolbar;
